import React, { Component, useEffect, useState } from "react";
import InfoHeader from "../comman/infoHeader";
import config from "../config.json";
import geo from "../services/geoService";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import FileSaver from "file-saver";
import { Modal, Button } from "react-bootstrap";
import Moment from "react-moment";
import { Link, useLocation, useNavigate } from "react-router-dom";
import WorkflowElement from "../app/components/WorkflowElement";
import { useDispatch, useSelector } from "react-redux";
import { getTemplateForm, loadTemplateForm } from "../app/store/template";

const PrintTemplate = () => {
  const state = {
    route: [{ name: "Home", url: "/" }],
    wfForm: {},
    aWorkfinityAppEntity: {},
    aWorkfinityApp: {},
    stateList: [],
    data: {},
    errors: {},
  };

  const [wfTask, setWfTask] = useState(null);
  const [updatedStateData, setUpdatedStateData] = useState(null);
  const [saveBtnProcessStatus, setSaveBtnProcessStatus] = useState(false);
  const [wfForm, setWfForm] = useState(null);

  const templateFormSelector = useSelector(getTemplateForm);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const state = location.state;
    if (state?.item) {
      setWfTask({ formId: state.item.templateId, ciid: state.item.ciid });
      dispatch(loadTemplateForm(state.item.templateId));
    }
  }, []);

  useEffect(() => {
    if (templateFormSelector) setWfForm(templateFormSelector);
  }, [templateFormSelector]);

  const handleNextTask = (data) => {
    //handleSubmit(data);
  };

  return (
    <React.Fragment>
      <div className="col-md-12 text-right mb-2">
        <button
          type="button"
          className="btn btn-outline-default btn-sm btn-min-width"
          onClick={() => navigate(-1)}
        >
          <i className="fa fa-arrow-left mr-2" aria-hidden="true"></i>Back
        </button>
      </div>

      <div className="col-md-12">
        {wfTask?.formId > 0 && (
          <WorkflowElement
            wfTask={wfTask}
            wfForm={wfForm}
            handleNextTask={handleNextTask}
            viewType={false}
            appSummary={false}
            codeVerified={true}
            wfTaskType={"template"}
            saveBtnProcessStatus={saveBtnProcessStatus}
            setSaveBtnProcessStatus={setSaveBtnProcessStatus}
            updatedStateData={updatedStateData}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default PrintTemplate;
